import React from 'react';
import { Box, Grid, Typography, Stack } from '@nextiva/next-ui-components';
import * as LicenseTypes from 'types/License';
import * as LaunchpadConstants from 'constants/launchpad';
import {
  downloadDesktopApp,
  navigateToConnect,
  navigateToLicenses,
} from 'utils/launchpad';
import LaunchpadBannerImage from './launchpad-banner.svg';
import {
  StyledBannerButtonWhite,
  StyledBannerButtonDark,
} from './Banner.styled';

const TEST_ID = `${LaunchpadConstants.TEST_ID}-Banner`;

interface LaunchpadBannerProps {
  connectLicense: LicenseTypes.License;
}

export const LaunchpadBanner = ({ connectLicense }: LaunchpadBannerProps) => (
  <Box
    sx={{
      backgroundColor: (theme) => theme.palette.primary.main,
      borderRadius: '8px',
    }}
    data-testid={TEST_ID}
  >
    <Grid container>
      <Grid item xs={8}>
        <Box
          sx={{
            padding: '32px',
          }}
        >
          <Typography
            variant="h3"
            color="white"
            sx={{
              marginBottom: '24px',
            }}
            data-testid={`${TEST_ID}-Title`}
          >
            {LaunchpadConstants.BANNER_TITLE}
          </Typography>

          <Typography
            variant="h5"
            color="white"
            sx={{
              marginBottom: '24px',
            }}
            data-testid={`${TEST_ID}-Subtitle`}
          >
            {LaunchpadConstants.BANNER_SUBTITLE}
          </Typography>

          <Box>
            {connectLicense ? (
              <>
                <StyledBannerButtonWhite
                  size="large"
                  sx={{ margin: '0 8px 0 0' }}
                  data-testid={`${TEST_ID}-DownloadDesktopApp-Button`}
                  onClick={downloadDesktopApp}
                >
                  Download the desktop app
                </StyledBannerButtonWhite>

                <StyledBannerButtonDark
                  data-testid={`${TEST_ID}-UseWeb-Button`}
                  onClick={navigateToConnect}
                >
                  Use the web version
                </StyledBannerButtonDark>
              </>
            ) : (
              <StyledBannerButtonWhite
                size="large"
                sx={{ margin: '0 8px 0 0' }}
                data-testid={`${TEST_ID}-AddLicense-Button`}
                onClick={navigateToLicenses}
              >
                Add a license to join your team today
              </StyledBannerButtonWhite>
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="flex-end"
          height="100%"
        >
          <LaunchpadBannerImage />
        </Stack>
      </Grid>
    </Grid>
  </Box>
);
